import React, { Component } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import asyncComponent from './hoc/asyncComponent/asyncComponent';

import Layout from './hoc/Layout/Layout'
import Flight from './containers/Flight/Flight'
import Logout from './containers/Auth/Logout/Logout';
import * as actions from './store/actions/index';

const asyncFlightDetaliedReport = asyncComponent(() => {
  return import('./containers/Reports/flightDetailedReport/flightDetailedReport');
});

const asyncdataEntry = asyncComponent(() => {
  return import('./containers/DataEntry/DataEntry');
});

const asyncReports = asyncComponent(() => {
  return import('./containers/Reports/Reports');
});

const asyncAuth = asyncComponent(() => {
  return import('./containers/Auth/Auth');
});

class App extends Component {
  componentDidMount () {
    this.props.onTryAutoSignup();
  }

  render () {
    let routes = (
      <Switch>
        <Route path="/" component={asyncAuth} />
        <Redirect to="/" />
      </Switch>
    );
    
    if ( this.props.isAuthenticated ) {
      routes = (
        <Switch>
          <Route path="/flight" component={asyncFlightDetaliedReport} />
          <Route path="/report" component={asyncReports} />
          <Route path="/logout" component={Logout} />
          <Route path="/auth" component={asyncAuth} />
          <Route path="/dataEntry" exact component={asyncdataEntry} />
          <Route path="/" component={Flight} />
          <Redirect to="/" />
        </Switch>
      );
    }

    return (
      <div>
        <Layout>
          {routes}
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch( actions.authCheckState() )
  };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );
